import { SectionIds } from '@modeso/aumico-lib-annualreport-fe';
import { localizationKeys } from '../../../utils/localizationKeys';

export const SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY: { [key: string]: { localizationKey: string } } = {};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.BALANCE] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_balance,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.INCOME] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_income,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.APBS] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_account_proof_for_balance,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.APIS] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_account_proof_for_income,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.CASHFLOW] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_cashflow,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.NOTES] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_attachement,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.AOP] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_aop,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.EMS] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_ems,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.FAS] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_fas,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.FINANCIAL_CLOSING_PROCESS] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_fcp,
};
SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.APPENDIX] = {
    localizationKey: localizationKeys.aumico_annual_report_print_preview_appendix_section_title,
};
